module.exports = __webpack_public_path__ + "img/ico_top_01.0960b85d.png";